<template>
  <div class="container-fluid" id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
  @import "styles/style.scss";
  @import "styles/office.css";
</style>
